<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column
            h3.is-size-3 
              | Alta de Artículos
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-4
            .field
              input#switchCompra.switch.is-rounded(type='checkbox' name='switchCompra' v-model='isCompra')
              label.is-size-6(for='switchCompra') Desde Compra
        .columns
          .column.is-5
            .field
              label.label Tipo
              .control
                typeahead(:options="showArticulos" :optionSelect="itemData" :tema="typeTipos" v-model="itemSel")
          .column.is-2
            .field
              label.label # Serie
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Serie',
                  v-model="articulo.serie",
                  @keydown.tab="buscarSerie"
                )
          .column.is-2
            .field
              label.label Moneda
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="articulo.moneda" :disabled="isDisabled")
                    option(v-for="m in monedas" :key="m.id" :value="m.id") {{ m.prefijo }} {{ m.moneda }}
          .column.is-2
            .field
              label.label Precio Unitario
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='15.90',
                  v-model="articulo.precioUnitario",
                  :disabled="isDisabled"
                )
        .columns.is-vcentered
          .column.is-2
            .field
              label.label # Parte
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Serie',
                  v-model="articulo.noParte"
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              input.is-checkradio.is-dark(type='checkbox'  id="checkCajaChica" v-model="articulo.cajaChica")
              label.is-size-6(for="checkCajaChica") Caja Chica
          .column.is-2(v-show="!articulo.cajaChica")
            .field
              label.label Orden de Compra
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Orden de Compra',
                  v-model="articulo.ordenCompra",
                  :disabled="isDisabled"
                )
          .column.is-2(v-show="!articulo.cajaChica")
            .field
              label.label # Partida
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Serie',
                  v-model="articulo.partida"
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label Fecha de Compra:
              .control
                flat-pickr(
                  v-model='articulo.fechaCompra'
                  :config="config"
                  class="input is-dark"
                  :disabled="isDisabled"
                )
        .columns.is-vcentered   
          .column.is-2
            .field
              label.label Estado
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="articulo.estado" :disabled="isDisabled")
                    option(v-for="e in estados" :value="e.id") {{ e.estado }}
                .icon.is-small.is-left
                  i.fas.fa-box-open
          .column.is-2
            .field
              label.label Localización
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="articulo.localizacion" :disabled="isDisabled")
                    option(v-for="l in localizacionesFilter" :key="l.id" :value="l.id") {{ l.localizacion }}
          .column.is-2
            .field
              input#checkGarantia.is-checkradio.is-circle(type='checkbox' name='checkPrioridad' v-model="articulo.garantia")
              label.is-size-6(for='checkGarantia') Garantía
          .column.is-2
            .field(v-show="articulo.garantia")
              label.label Término Garantía
              .control
                flat-pickr(
                  v-model='articulo.finishGarantia'
                  :config="config"
                  class="input is-dark"
                  :disabled="isDisabled"
                )
        .columns
          .column.is-6
            .field
              label.label Observaciones
              .control
                textarea.textarea.is-dark(
                  type='text', 
                  placeholder='Observaciones',
                  v-model="articulo.observaciones",
                  @keyup.enter="saveArticulo"
                  :disabled="isDisabled"
                  rows="2"
                )
          .column.is-2(v-show="verTag")
            .field
              label.label Tag
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Tag',
                  v-model="articulo.tag",
                  :disabled="isDisabled"
                )
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger {{ datosF }}
        .columns
          .column.is-3
            a.button.is-black.is-rounded.is-medium(:disabled="isDisabled" @click="checkForm") Guardar
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'


import moment from 'moment'
import { mapState } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default {
  name: 'NuevoArticulo',
  components: { Loader, NavBarInventario, Typeahead, flatPickr },
  data () {
    return {
      isDisabled: true,
      isEditing: false,
      isSaved: false,
      isLoading: true,
      isCompra: false,
      tipos: [],
      compras: [],
      showArticulos: [],
      marcas: [],
      articulo: {
        id: '',
        serie: '',
        marca: '',
        modelo: '',
        observaciones: '',
        categoria: '',
        subcategoria: '',
        tag: '',
        direccionIP: '',
        macAddressW: '',
        macAddressE: '',
        fechaReg: '',
        ubicacion: '',
        oficina: '',
        ordenCompra: '',
        precioUnitario: 0.00,
        fechaCompra: '',
        garantia: '',
        finishGarantia: '',
        idIngresa: '',
        ingresa: '',
        idResguardo: '',
        resguardo: '',
        estado: 0,
        cajaChica: true,
        moneda: 1,
        localizacion: 0,
        partida: '',
        noParte: '',
      },
      ubicacionStr: '',
      oficinaStr: '',
      idUserAlmacen: '',
      userAlmacen: '',
      itemSel: {},
      itemData: {},
      marcaSel: {},
      marcaData: {},
      oficinas: [],
      oficinasSel: [],
      config: {
        wrap: false, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only
      },
      typeMarca: 'marca',
      typeTipos: 'tipos',
      existeSerie: false,
      datosFaltantes: [],
      almacenes: [],
      origen: {},
      monedas: [],
      estados: [
        { id: 0, estado: 'NUEVO' },
        { id: 1, estado: 'USADO' },
        { id: 7, estado: 'PRUEBAS' },
        { id: 8, estado: 'INSTALADO' },
        { id: 9, estado: 'REPARACIÓN' },
        { id: 10, estado: 'DESECHADO' },
      ],
      verTag: false,
      localizaciones: [],
      localizacionesFilter: [],
    }
  },
  watch: {
    'articulo.ubicacion'() {
      this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.articulo.ubicacion)
    },
    existeSerie () {
      if (this.existeSerie) {
        this.displayToast('bubble','El artículo o dispositivo ya existe en la Base de Datos.', 'ban', 'Ok')
        this.isDisabled = true  
      } else {
        this.isDisabled = false
      }
    },
    isCompra () {
      if (this.isCompra) {
        this.showArticulos = this.compras
      } else {
        this.showArticulos = this.tipos
      }
    },
    itemSel () {
      if (this.itemSel.tipoAdm == 0 || this.itemSel.tipoAdm == 4) {
        return false
      }
      this.getTag(this.itemSel.tipoAdm)
    },
  },
  methods: {
    iniciarComponente() {
      this.obtenerOficinas()
    },

    obtenerOficinas() {
      InventarioServices.getOficinas()
        .then( data => {
          this.oficinas = data.map(this.convertirOficinas)
          this.obtenerMonedas()
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
    },

    convertirOficinas(ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        oficina: ofi.nombre,
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },

    obtenerTipos () {
      InventarioServices.getBaseArticulos()
        .then(res => {
          if (res.length > 0) {
            this.tipos = res.map(this.convertArticulo)
            this.showArticulos = this.tipos
            this.obtenerArticulosCompras()
          }
          
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',e.message, 'ban', 'OK')
        })
        
    },

    obtenerArticulosCompras () {
      InventarioServices.getArticulosCompras()
        .then( data => {
          console.log(data)
          this.compras = data.map(this.convertirCompra)
          this.isCompra = data.length > 0
          this.obtenerOrdenCompra()
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',e.message, 'ban', 'OK')
        })

    },

    convertArticulo (art) {
      const subcat = art.subcategoria === '' ? '' : ` - ${art.subcategoria}`
      const model = art.modelo === '' ? '' : ` - ${art.modelo}`
      const marc = art.marca === '' ? '' : ` | ${art.marca}`
      const texto = `${art.categoria}${subcat}${marc}${model}`
      return {
        ...art,
        id: parseInt(art.id),
        text: texto,
        tipoAdm: parseInt(art.tipoAdm),
      }
    },

    convertirCompra (compra) {
      return {
        ...compra,
        id_ri: parseInt(compra.id_ri),
        id_requisicion: parseInt(compra.id_requisicion),
        id_ticket: parseInt(compra.id_ticket),
        id_solicitud: parseInt(compra.id_solicitud),
        cantidad: parseInt(compra.cantidad),
        unidadMedida: parseInt(compra.unidadMedida),
        precioUnitario: parseInt(compra.precioUnitario),
        importe: parseInt(compra.importe),
        area: parseInt(compra.area),
        text: `${compra.marca} - ${compra.modelo} ~ ${compra.categoria} ${compra.subcategoria}`

      }
    },
    
    getTipo: function (id) {
      let result;
      let type = this.tipos.filter(tipo => tipo.id === id)
      let tipoEnc = type[0]
      if (tipoEnc.subcategoria === '') {
        result = tipoEnc.categoria
      } else {
        result = `${tipoEnc.categoria} (${tipoEnc.subcategoria})`
      }
      return result
    },

    checkForm () {
      if (this.isDisabled) {
        return
      }
      this.datosFaltantes = []
      if (Object.keys(this.itemSel).length > 0 && this.articulo.serie !== '' && this.articulo.fechaCompra !== '' && this.articulo.estado !== '' && this.articulo.moneda > 0) {
        this.saveArticulo()
      } else {
        if (!Object.keys(this.itemSel).length > 0) {
          this.datosFaltantes.push('El Artículo es requerido.')
        }

        if (this.articulo.serie ==='') {
          this.datosFaltantes.push('La serie del artículo es requerido.')
        }

        if (this.articulo.fechaCompra ==='') {
          this.datosFaltantes.push('La fecha de compra del artículo es requerido.')

        }
        if (this.articulo.estado ==='') {
          this.datosFaltantes.push('El estado del artículo es requerido.')
        }

        if (this.articulo.moneda == 0) {
          this.datosFaltantes.push('La Moneda del artículo es requerido.')
        }
      }
    },

    saveArticulo () {
      this.isLoading = true
      
      let garantiaInt
      if (this.articulo.garantia) {
        garantiaInt = 1
      } else {
        garantiaInt = 0
      }

      let termGarantia = null
      if (this.articulo.finishGarantia === '') {
        termGarantia = null
      } else {
        termGarantia = this.articulo.finishGarantia
      }
        
        let idArt = Date.now()
        let idUbi = Date.now()
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        this.articulo.id = idArt
        this.articulo.idIngresa = this.userLogin.id
        this.articulo.ingresa = this.userLogin.nombre
        this.articulo.idResguardo = this.userLogin.id
        this.articulo.resguardo = this.userLogin.nombre
        console.log('No es reincorporación')

        InventarioServices.addArticulo(this.articulo.id,'_CREADO',this.articulo.serie,this.itemSel.marca,
        this.itemSel.modelo,this.articulo.observaciones,this.itemSel.id_cat,this.itemSel.categoria,
        this.itemSel.id_subcat,this.itemSel.subcategoria,this.itemSel.id,ahora,this.ubicacionStr,
        this.oficinaStr, this.articulo.cajaChica ? '' : this.articulo.ordenCompra, this.articulo.estado,
        this.articulo.idIngresa, this.articulo.ingresa,this.idUserAlmacen,this.userAlmacen,idUbi, 
        this.articulo.fechaCompra, termGarantia, garantiaInt, this.articulo.moneda, this.articulo.precioUnitario, 
        this.articulo.cajaChica ? 1 : 0, this.articulo.tag, this.articulo.partida, this.articulo.noParte, this.articulo.localizacion)
          .then( res => {
            
            if (res.success) {
              InventarioServices.addUbicacion(idUbi,this.articulo.id,ahora,this.ubicacionStr,this.oficinaStr,this.articulo.idIngresa,this.articulo.ingresa,this.idUserAlmacen,this.userAlmacen, 0)
                .then(data => {
                  
                  if (data.success) {

                    if (this.isCompra) {
                      InventarioServices.updateRequisicionItem(this.itemSel.id_ri, this.articulo.id)
                        .then( dataIR => {

                          this.displayToast(dataIR.success ? 'toasted-primary' : 'bubble', dataIR.respuesta, dataIR.success ? 'done' : 'ban', 'OK')
                          this.limpiarForm()
                          this.isLoading = false
                          this.$router.back()
                        })
                        .catch( e => {
                          this.isLoading = false
                          this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
                        })
                    } 
                    this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
                    this.limpiarForm()
                    this.isLoading = false
                    this.$router.back()
                  } else {
                    this.isLoading = false
                  }
                })
                .catch((e1) => {
                  this.isLoading = false
                  this.displayToast('bubble',e1.message, 'ban', 'OK')
                })
              
            } else {
              this.displayToast('bubble',res.respuesta, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      

    },

    limpiarForm () {
      this.articulo.serie = ''
      this.articulo.estado = ''
      this.articulo.observaciones = ''
    },

    obtenerOrdenCompra () {
      let year = moment().format('YY')
      let month = moment().format('MM')
      
      this.articulo.ordenCompra = `DUCTER-${year}${month}-`
      this.isLoading = false
    },
    
    comprobarExiste () {
      console.log(this.itemSel.marca)
    },

    buscarSerie () {
      if (this.articulo.serie.length > 0) {
        InventarioServices.getSerie_exist(this.articulo.serie)
          .then((data) => {
            if (Object.keys(data).length > 0) {
              if (parseInt(data[0].existe) > 0) {
                this.existeSerie = true
              } else {
                this.existeSerie = false
                this.isDisabled = false
              }
            }
          })
          .catch((e) => {
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      }
    },

    displayToast(tema, text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },

    backPage () {
      this.$router.back()
    },

    obtenerAlmacenes () {
      InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirAlmacenes (ofi) {
      const ubi = ofi.ubicacion === 'CORPORATIVO' ? 'CORP' : ofi.ubicacion
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_oficina: parseInt(ofi.id_oficina),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
        ubicacion: ubi,
      }
    },
    
    obtenerAlmacenOrigen() {
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
          this.origen = alm
        }
      })
      this.ubicacionStr = this.origen.ubicacion
      this.oficinaStr = this.origen.clave
      this.idUserAlmacen = this.origen.id_resguardo
      this.userAlmacen = this.origen.resguardo
      this.obtenerLocalizaciones()
    },
    
    obtenerMonedas() {
      InventarioServices.getMonedas()
        .then( data => {
          this.monedas = data.map(this.convetirMonedas)
          this.obtenerTipos()
          this.obtenerAlmacenes()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convetirMonedas(moneda) {
      return {
        ...moneda,
        id: parseInt(moneda.id)
      }
    },

    getTag(tipo) {
      InventarioServices.getTag(tipo)
        .then(data => {
          const tags = data[0].tag.split('-')
          const tagInt = parseInt(tags[1]) + 1
          let prefijo = ''
          switch (tipo) {
            case 1:
              prefijo = 'ET-'
              break
            case 2:
              prefijo = 'TM-'
              break
            case 3:
              prefijo = 'ME-'
              break
            case 5:
              switch (tagInt.toString().length) {
                case 1:
                  prefijo = 'PS-00'
                  break
                case 2:
                  prefijo = 'PS-0'
                  break
                case 3:
                  prefijo = 'PS-'
                  break
              }
              break
            case 6:
              switch (tagInt.toString().length) {
                case 1:
                  prefijo = 'GS-00'
                  break
                case 2:
                  prefijo = 'GS-0'
                  break
                case 3:
                  prefijo = 'GS-'
                  break
              }
              break
            case 7:
              prefijo = 'HT-'
              break
            case 8:
              switch (tagInt.toString().length) {
                case 1:
                  prefijo = 'MQ-00'
                  break
                case 2:
                  prefijo = 'MQ-0'
                  break
                case 3:
                  prefijo = 'MQ-'
                  break
              }
              break
          }
          this.verTag = true
          this.articulo.tag = `${prefijo}${tagInt}`
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    obtenerLocalizaciones() {
      InventarioServices.getLocalizaciones()
        .then( data => {
          this.localizaciones = data.map(this.convertirLocalizaciones)
          this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == this.origen.id_oficina)
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirLocalizaciones(loc) {
      return {
        ...loc,
        id: parseInt(loc.id),
        id_oficina: parseInt(loc.id_oficina),
      }
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['userLogin', 'almacenSelect'])
  }
}
</script>

<style lang="css" scoped>
  
  #checkGarantia {
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/NuevoArticulo.vue